import { User, UserAccess } from 'shared/interfaces/User';

export const DEFAULT_USER_AVATAR_KEY = 'default-user-avatar';

export const EMPTY_USER: User = {
  _id: '',
  cognitoId: '',
  firstName: '',
  lastName: '',
  email: '',
  avatarPath: DEFAULT_USER_AVATAR_KEY,
  role: UserAccess.NULL,
  createdAt: 0,
  organisation: '',
  isActive: false,
  isInCustomOrganisation: false,
  hasCompletedOnboarding: false
};
